import api from "./base-api"


const dsChargeApi = api.injectEndpoints({
    endpoints: (build) => ({
        getGuidMapDS: build.query({
            query: () => `v2/ds/states/guid-map`
        }),
        getChargesDS: build.query({
            query: (userId = "") => `v2/ds/charges/${userId}`,
            providesTags: ['Charges']
        }),
        createChargeDS: build.mutation({
            query: (body = {}) => ({
                url: `v2/ds/charges`,
                method: "POST",
                body: body
            }),
            invalidatesTags: ['Charges', 'DSChargerLogsById', 'DSChargerLogs'],
        }),
        createMassChargeDS: build.mutation({
            query: (body = new FormData()) => ({
                url: `v2/ds/charges`,
                method: "POST",
                body: body
            })
        }),
        dischargeDS: build.mutation({
            query: (body = []) => ({
                url: `v2/ds/charges/discharge`,
                method: "PUT",
                body: body
            })
        })
    }),
    overrideExisting: false
})

export const selectGuidMapDS = (state) => api.endpoints.getGuidMapDS.select()(state).data


export const {
    useGetGuidMapDSQuery,
    useGetChargesDSQuery,
    useCreateChargeDSMutation,
    useCreateMassChargeDSQuery
} = dsChargeApi
